import { combineReducers } from 'redux';
import userProfile from './user_profile';
import practitionerMetricSettings from './practitioner_metric_settings';
import clientPrimaryPractice from './client_primary_practice';

export default combineReducers({
    userProfile,
    practitionerMetricSettings,
    clientPrimaryPractice,
});